module.exports = __webpack_public_path__ + "static/media/DSC_0006.3444baca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0006.jpg
// module id = 583
// module chunks = 0